import { QueryClientProvider } from '@tanstack/react-query';
import { ReactElement } from 'react';

import { queryClient, QueryDevTools } from '../data/queryClient';

type Props = {
  devTools?: boolean;
  children: ReactElement;
};

function RhinoProvider({ children, devTools }: Props) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}

      {devTools && <QueryDevTools />}
    </QueryClientProvider>
  );
}

export { RhinoProvider };
